// Categories Grid
(() => {
  const categoryGrid = document.querySelector('.category-section');
  if (!categoryGrid) return;

  categoryGrid.querySelectorAll('.quicklinks > ul > li > a').forEach((item) => {
    const cloned = item.cloneNode(true);
    cloned.textContent = 'See More';
    item.nextElementSibling.append(cloned);
  });
})();
